import { DocumentAPI } from '../../../api/datamanager/DocumentAPI';

export class DocumentsCommand {
    listBusScheds(providerId, successCallback, errorCallback) {
        const apiResult = DocumentAPI.listBusScheds(providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os horários");
            }
        });
    }
    
    listBusMaps(providerId, successCallback, errorCallback) {
        const apiResult = DocumentAPI.listBusMaps(providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os mapas esquemáticos");
            }
        });
    }
}
